<ng-template #eventRef let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">{{ investigated }} Investigation Results</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="col-12">
				<span style="text-align:center;" [innerHtml]="investigation"></span>
			</div>
		</div>
	</div>
</ng-template>

<div class="main-content inventory-upload-page">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-5">
						<h4 class="card-title mb-0 d-flex align-items-center">
							<i class="material-icons inv-upload-back" (click)="back()" (keydown.enter)="back()" tabindex="0" role="button">arrow_back</i>
							<span class="ml-1">Inventory Upload</span>
						</h4>
					</div>
					<div class="card-body p-0">
						<div class="d-flex justify-content-between align-items-center flex-wrap px-3 pt-3 inv-upload-toolbar mb-1">
							<div class="mb-0 text-muted small" *ngIf="files.length">
								<span class="font-weight-bold text-dark">{{ files[0].name }}</span>
								<span *ngIf="inventoryReviewReady"> · {{ uploaddata?.length }} row(s)</span>
							</div>
							<button
								mat-stroked-button
								type="button"
								class="mt-1"
								(click)="$event.preventDefault(); toggleUploadHelp()"
								(keydown.enter)="$event.preventDefault()">
								Help
							</button>
						</div>

						<div class="inv-upload-body w-100 px-3 pb-2">
							<ng-container *ngIf="!uploadHelp">
								<div *ngIf="!preview">
									<div class="row">
										<div class="col-lg-5 mb-3">
											<mat-card class="inv-upload-panel h-100">
												<mat-card-subtitle class="inv-upload-card-heading">What to import</mat-card-subtitle>
												<mat-card-content>
													<p class="text-muted small mb-3">Turn on each data type you are loading. More column mappings appear in the next step.</p>
													<form [formGroup]="optionForm" class="d-flex flex-column inv-upload-toggle-col">
														<mat-slide-toggle formControlName="stockmaster">Item import</mat-slide-toggle>
														<mat-slide-toggle formControlName="prices">Item prices</mat-slide-toggle>
														<mat-slide-toggle formControlName="purchdata">Purchase data</mat-slide-toggle>
														<mat-slide-toggle formControlName="pricematrix">Quantity breaks</mat-slide-toggle>
														<mat-slide-toggle formControlName="ecomdesc" *ngIf="config?.env?.package === 'beauty'">E-commerce Descriptions</mat-slide-toggle>
														<mat-slide-toggle formControlName="tireinfo" *ngIf="config?.env?.package === 'tires'">Tire info</mat-slide-toggle>
													</form>
													<div class="mt-3 pt-2 border-top">
														<button mat-stroked-button type="button" (click)="downloadInventoryUploadTemplate()" [disabled]="processing_recs">
															<mat-icon>file_download</mat-icon>
															Download XLSX template
														</button>
													</div>
												</mat-card-content>
											</mat-card>
										</div>
										<div class="col-lg-7 mb-3">
											<mat-card class="inv-upload-panel h-100">
												<mat-card-subtitle class="inv-upload-card-heading">File &amp; header row</mat-card-subtitle>
												<mat-card-content>
													<p class="text-muted small mb-3">
														<strong>Header row #</strong> is the row that contains your <strong>column headings</strong> (not the first row of data). Use <strong>1</strong> if headings are on the first row of the sheet; data should follow on the rows below. After the file loads, map each heading to a system field.
														Dropping a file only reads it in your browser. <strong>Pre-Process</strong> validates mapped rows with the server; <strong>Submit Upload</strong> applies the import.
													</p>
													<mat-form-field appearance="outline" class="w-100 inv-upload-header-row-field">
														<mat-label>Header row #</mat-label>
														<input matInput type="number" min="1" [formControl]="rowNumber" />
														<mat-hint>Which row has the headings? Change this and click Re-read if you adjust the sheet.</mat-hint>
													</mat-form-field>

													<div *ngIf="!processing_recs && !inventoryReviewReady">
														<ngx-dropzone
															class="inv-upload-dropzone"
															[ngClass]="'inv-upload-dropzone--' + dropzoneThemeColor"
															[multiple]="false"
															[expandable]="true"
															accept=".csv,.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/plain"
															(change)="onSelect($event)">
															<ngx-dropzone-label>
																<div class="order-upload-dropzone__inner">
																	<mat-icon class="order-upload-dropzone__icon" aria-hidden="true">cloud_upload</mat-icon>
																	<span class="order-upload-dropzone__title">Drop one file here</span>
																	<span class="order-upload-dropzone__hint"
																		>CSV or Excel (.xlsx, .xls) — first sheet only. The file is read in your browser as soon as you add it.</span
																	>
																</div>
															</ngx-dropzone-label>
															<ngx-dropzone-preview *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
																<ngx-dropzone-label class="order-upload-file-label">{{ f.name }} · {{ formatFileSizeKb(f.size) }} KB</ngx-dropzone-label>
															</ngx-dropzone-preview>
														</ngx-dropzone>
														<div class="d-flex flex-wrap align-items-center mt-2" *ngIf="files.length">
															<button mat-stroked-button color="warn" type="button" class="mr-2 mb-1" (click)="clearAllFiles()" [disabled]="processing_recs">
																<mat-icon>delete_sweep</mat-icon>
																Remove file
															</button>
														</div>
													</div>

													<div *ngIf="inventoryReviewReady" class="mt-2">
														<div class="d-flex align-items-center flex-wrap inv-upload-loaded-file">
															<mat-icon class="text-success mr-1" style="font-size: 20px; width: 20px; height: 20px;">insert_drive_file</mat-icon>
															<span class="small text-dark mr-2 text-truncate" style="max-width: 280px;">{{ files[0]?.name }}</span>
															<button mat-stroked-button type="button" color="warn" class="py-0" (click)="clearAllFiles()">
																<mat-icon>close</mat-icon>
																Remove
															</button>
														</div>
														<p class="small text-muted mb-0 mt-2">
															Use <strong>Re-read file</strong> after changing the header row or import options.
														</p>
													</div>
												</mat-card-content>
												<mat-card-actions align="end" class="pb-3 pt-0" *ngIf="files.length && !processing_recs">
													<button mat-stroked-button type="button" (click)="rereadFile()">
														<mat-icon>refresh</mat-icon>
														Re-read file
													</button>
												</mat-card-actions>
											</mat-card>
										</div>
									</div>
								</div>

								<div class="order-upload-processing text-center py-4" *ngIf="processing_recs">
									<mat-spinner diameter="48" class="order-upload-processing__spinner"></mat-spinner>
									<p class="order-upload-processing__title mt-3 mb-1">Reading file…</p>
									<p class="order-upload-processing__hint text-muted small mb-0">Parsing the spreadsheet and matching columns.</p>
								</div>

								<mat-card class="inv-upload-panel mt-2 mb-3" *ngIf="inventoryReviewReady && uploaddata?.length && !preview">
									<mat-card-subtitle class="inv-upload-card-heading">Map columns</mat-card-subtitle>
									<mat-card-content>
										<div class="alert alert-info d-flex align-items-start py-2 mb-3">
											<mat-icon class="flex-shrink-0 mr-2">auto_awesome</mat-icon>
											<div class="small mb-0">
												Each file column can map to one or more system fields. Suggestions are automatic — use the multi-selects under your headers, or <strong>Suggest mappings</strong> to re-run.
											</div>
										</div>
										<div class="d-flex flex-wrap align-items-center mb-3">
											<button mat-stroked-button type="button" color="primary" (click)="suggestMappings()">
												<mat-icon>psychology</mat-icon>
												Suggest mappings
											</button>
										</div>
										<div *ngIf="unmappedRequiredFields.length" class="alert alert-warning py-2 mb-3 inv-upload-missing-required">
											<div class="d-flex align-items-start">
												<mat-icon class="flex-shrink-0 mr-2 text-warning" style="font-size: 22px; width: 22px; height: 22px;">warning</mat-icon>
												<div class="small mb-0">
													<strong class="d-block mb-1">Required fields still need a column</strong>
													<p class="mb-1 text-muted">Pick a file column for each row below in the dropdowns (or use Suggest mappings).</p>
													<ul class="mb-0 pl-3">
														<li *ngFor="let m of unmappedRequiredFields">
															<strong>{{ m.label }}</strong>
															<code class="small ml-1 text-dark">{{ m.field }}</code>
														</li>
													</ul>
												</div>
											</div>
										</div>
										<div *ngIf="mappingPreviewTotal > inventoryMappingPreviewMax" class="alert alert-secondary small py-2 mb-2">
											Showing the first {{ inventoryMappingPreviewMax }} of {{ mappingPreviewTotal }} row(s).
											<strong>Pre-Process</strong> uses every row.
										</div>
										<div
											class="table-responsive inv-upload-mapping-table-wrap"
											[ngClass]="'inv-upload-mapping-table-wrap--' + dropzoneThemeColor">
											<table class="table table-bordered table-sm inv-upload-mapping-table mb-0">
												<thead>
													<tr>
														<th *ngFor="let h of fileColumnsForMapping" class="inv-upload-mapping-th-title text-muted small" [attr.title]="h">
															<span class="inv-upload-mapping-th-text">{{ h }}</span>
														</th>
													</tr>
													<tr>
														<th *ngFor="let h of fileColumnsForMapping" class="inv-upload-mapping-th-select p-1">
															<div class="inv-upload-select-wrap">
																<select
																	class="inv-upload-mapping-select"
																	[ngClass]="'inv-upload-mapping-select--' + dropzoneThemeColor"
																	multiple
																	[size]="mapcols.length > 6 ? 6 : mapcols.length"
																	(change)="onFileColumnMappingSelectChange(h, $event)">
																	<option value=""> == DO NOT MAP == </option>
																	<option
																		*ngFor="let m of mapcols"
																		[value]="m.field"
																		[selected]="isFieldMappedToHeader(m.field, h)"
																		[disabled]="isFieldMappedToOtherHeader(m.field, h)">
																		{{ m.label }}<ng-container *ngIf="m.req"> *</ng-container>
																	</option>
																</select>
															</div>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let row of mappingPreviewRows">
														<td *ngFor="let h of fileColumnsForMapping" class="inv-upload-mapping-td small">{{ row[h] }}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</mat-card-content>
								</mat-card>

								<mat-card class="inv-upload-panel mb-3" *ngIf="inventoryReviewReady && preview && mappeddata.length">
									<mat-card-subtitle class="inv-upload-card-heading">Preview</mat-card-subtitle>
									<mat-card-content class="p-0 pt-2">
										<div class="table-responsive inv-upload-preview-wrap">
											<table class="table table-striped table-sm inv-upload-preview-table mb-0">
												<thead>
													<tr>
														<th class="inv-upload-actions-col"></th>
														<th *ngFor="let m of mapped">{{ m.label }}</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let row of mappeddata" [ngClass]="{ hasProblem: row?.problem }">
														<td>
															<button mat-icon-button type="button" (click)="investigate(row)" title="Investigate">
																<mat-icon>search</mat-icon>
															</button>
															<div *ngIf="row.problem" class="small text-danger mt-1" [innerHtml]="row.problem"></div>
														</td>
														<td *ngFor="let col of mapped">{{ row[col.field] }}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</mat-card-content>
								</mat-card>
							</ng-container>

							<ng-container *ngIf="uploadHelp">
								<div class="row py-2">
									<div class="col-md-6">
										<h4 class="font-weight-bold">Import types</h4>
										<ul class="small">
											<li><strong>Item import</strong> — stock master fields (description, UOM, brand, etc.).</li>
											<li><strong>Item prices</strong> — price level, currency, sales price, optional dates.</li>
											<li><strong>Purchase data</strong> — vendor, purchase price, UOM, dates.</li>
											<li><strong>Quantity breaks</strong> — break qty, break price, date range.</li>
											<li *ngIf="config?.env?.package === 'tires'"><strong>Tire info</strong> — when enabled for your package.</li>
										</ul>
										<hr />
										<h4 class="font-weight-bold">Header row</h4>
										<p class="small text-muted mb-0">
											<strong>Header row #</strong> is the row with <strong>column headings</strong>, not data. Enter <strong>1</strong> if headings are on the first row of the sheet. The rows below should be your data.
										</p>
									</div>
									<div class="col-md-6 mt-3 mt-md-0 border-md-left pl-md-4">
										<h4 class="font-weight-bold">Workflow</h4>
										<ol class="small">
											<li>Choose import types and set <strong>Header row #</strong> if headings are not on row 1.</li>
											<li>Drop <strong>one</strong> file — it is read in the browser right away.</li>
											<li>Map file columns to system fields (suggestions are automatic), then run <strong>Pre-Process</strong> to validate.</li>
											<li>Review the preview, then <strong>Submit Upload</strong> to apply the import. Until then, inventory is not updated.</li>
										</ol>
										<hr />
										<h4 class="font-weight-bold">Supported formats</h4>
										<ul class="small mb-0">
											<li>Excel (.xlsx, .xls)</li>
											<li>CSV (.csv)</li>
										</ul>
									</div>
								</div>
							</ng-container>
						</div>

						<div
							class="inv-upload-footer d-flex flex-wrap align-items-center px-3 py-3 border-top"
							[ngClass]="inventoryReviewReady && !preview && unmappedRequiredFields.length ? 'justify-content-between' : 'justify-content-end'">
							<div class="inv-upload-footer-missing flex-grow-1 pr-md-3 mb-2 mb-md-0" *ngIf="inventoryReviewReady && !preview && unmappedRequiredFields.length">
								<span class="small font-weight-bold text-danger d-block">Missing mappings</span>
								<ul class="small text-danger mb-0 pl-3 mt-1 inv-upload-missing-list">
									<li *ngFor="let m of unmappedRequiredFields">{{ m.label }} <span class="text-muted">({{ m.field }})</span></li>
								</ul>
							</div>
							<div class="d-flex flex-wrap align-items-center justify-content-end inv-upload-footer-actions">
							<button
								mat-stroked-button
								type="button"
								*ngIf="inventoryReviewReady && !preview"
								(click)="$event.preventDefault(); backFromParse()"
								(keydown.enter)="$event.preventDefault()">
								Back
							</button>

							<button
								mat-raised-button
								color="primary"
								type="button"
								*ngIf="inventoryReviewReady && !preview && uploaddata?.length"
								(click)="process(uploaddata)"
								[disabled]="mappingForm.invalid"
								[attr.title]="mappingForm.invalid && missingRequiredMappingSummary ? 'Map: ' + missingRequiredMappingSummary : null">
								<mat-icon>fact_check</mat-icon>
								Pre-Process
							</button>

							<button mat-stroked-button type="button" *ngIf="preview" (click)="remap()">Back to mapping</button>

							<button mat-raised-button color="accent" type="button" *ngIf="preview && mappeddata.length" (click)="submit()">
								<mat-icon>cloud_upload</mat-icon>
								Submit Upload
							</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
